import React from 'react';

import { useVariant } from '@helpers/hooks/pages/dashboard/kit/useVariant';
import { IVariantCardProps } from '@domain/interfaces/dashboard/Kit/variant';
import BlurredVariant from './BlurredVariant';
import FocusedVariant from './FocusedVariant';

import * as S from './styles';

const Variant: React.FC<IVariantCardProps> = ({ variant, index }) => {
  const { isCardExpanded, handleIndex, handleExistingVariant, initialVariant } = useVariant();

  React.useEffect(() => {
    if (index) {
      handleIndex(index);
    }

    if (variant?.variant) {
      handleExistingVariant(variant);
    }
  }, [variant, index, handleExistingVariant, handleIndex]);

  return (
    <S.Wrapper>
      {isCardExpanded || !initialVariant?.variant ? <FocusedVariant /> : <BlurredVariant />}
    </S.Wrapper>
  );
};

export default Variant;
